let lastScrollTop = 0;

function myScrollFunc() {
  const nav = document.querySelector('.primaryNav-container');
  const title = document.querySelector('.primaryNav-title');
  if (document.querySelector('.single-meta')) {
    const postMeta =
      document.querySelector('.single-meta').offsetHeight +
      document.querySelector('.single-meta').offsetTop;
    const y = document.documentElement.scrollTop;

    const st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop) {
      if (postMeta <= y) {
        title.className = 'primaryNav-title hide';
        nav.className = 'primaryNav-container show';
      } else {
        title.className = 'primaryNav-title hide';
        nav.className = 'primaryNav-container show';
      }
    } else {
      title.className = 'primaryNav-title hide';
      nav.className = 'primaryNav-container show';
    }

    lastScrollTop = st <= 0 ? 0 : st;
  }
}

window.addEventListener('scroll', myScrollFunc);
